import $ from 'jquery';
import 'jquery.validate';
import { hideValidationSummary } from 'ui-utils';

onLoad();

document.addEventListener('DOMContentUpdated', e => onLoad(e.target));

export function onLoad(context = document) {
    context.querySelectorAll('form').forEach(form => {
        form.addEventListener('invalid', e => {
            // If the trigger that submitted the form was not within a group then hide all validation summaries that are in a group.
            // Note: When the trigger is the window it doesn't contain a closest function.
            if (!e.detail?.trigger || typeof e.detail.trigger.closest !== 'function' || !e.detail.trigger.closest('[data-val-group]'))
                hideValidationSummary(form, null, '[data-val-group] ');
        });
    });
}

export default function validateGroup(form, group) {
    // Make sure the form exists.
    if (!form)
        throw `The validation group "${group}" is not within a form.`;

    const $form = $(form);

    // Set the original ignore expression.
    const ignore = $form.validate().settings.ignore;

    // Set the jQuery validator to ignore all fields apart from the ones with our group (ignore nested groups).
    $form.validate().settings.ignore = ignore.replace('[data-val-group] *', ':not([data-val-group="' + group + '"] *), [data-val-group="' + group + '"] [data-val-group] *');

    // Validate the form.
    const isValid = $form.valid();

    // If the form is not valid.
    if (!isValid)
        // Hide all validation summaries that are not in a group or doesn't match the group.
        hideValidationSummary(form, (i, el) => !$(el).closest('[data-val-group]').length || $(el).closest('[data-val-group]').data('val-group') != group);
    else
        // Hide all validation summaries.
        hideValidationSummary(form);

    // Set the jQuery validation ignored fields back to the default.
    $form.validate().settings.ignore = ignore;

    return isValid;
}